import { render } from "./ApiDocParamInfo.vue?vue&type=template&id=2d29f86c"
import script from "./ApiDocParamInfo.vue?vue&type=script&lang=js"
export * from "./ApiDocParamInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__